export class UpdateIntegrationResponse {
    'integration';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "integration",
            "baseName": "integration",
            "type": "IntegrationConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateIntegrationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
